module.exports = __webpack_public_path__ + "img/mpascensores-min.e689d30a.png";